var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "products", attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        { staticClass: "mt-21px", attrs: { row: "", "justify-center": "" } },
        [
          _c("p", { staticClass: "subtitle" }, [
            _vm._v("Productos Presenciales")
          ])
        ]
      ),
      _c(
        "v-layout",
        { attrs: { row: "", "justify-center": "" } },
        [
          _c(
            "v-btn-toggle",
            {
              staticClass: "option-toggle--outline text-xs-left elevation-0",
              attrs: { flat: "" },
              model: {
                value: _vm.selectedIndex,
                callback: function($$v) {
                  _vm.selectedIndex = $$v
                },
                expression: "selectedIndex"
              }
            },
            [
              _c(
                "v-layout",
                {
                  attrs: { wrap: "", column: "", row: "", "justify-center": "" }
                },
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-layout",
                        {
                          staticClass: "wrap__mobile",
                          attrs: { row: "", "justify-center": "" }
                        },
                        _vm._l(_vm.productsIcons.presential, function(item, i) {
                          return _c(
                            "v-btn",
                            {
                              key: i,
                              staticClass: "ma-2 option-toggle__btn",
                              attrs: { value: i },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.saveSolution($event)
                                }
                              }
                            },
                            [
                              _c("i", { class: item.icon }),
                              _c("div", { staticClass: "text-xs-left pl-3" }, [
                                _c("h3", {
                                  domProps: { innerHTML: _vm._s(item.title) }
                                }),
                                _c("p", {
                                  staticClass: "mb-0",
                                  domProps: { innerHTML: _vm._s(item.subtitle) }
                                })
                              ]),
                              _c("span", {
                                staticClass: "icon-ic-check",
                                class: { showCheck: i === _vm.selectedIndex }
                              })
                            ]
                          )
                        })
                      )
                    ],
                    1
                  ),
                  _c("v-flex", { staticClass: "mt-38px" }, [
                    _c(
                      "p",
                      { staticClass: "subtitle text-md-center text-xs-center" },
                      [_vm._v("Productos Virtuales")]
                    )
                  ]),
                  _c(
                    "v-flex",
                    { staticClass: "mb-5" },
                    [
                      _c(
                        "v-layout",
                        {
                          staticClass: "wrap__mobile",
                          attrs: { row: "", "justify-center": "" }
                        },
                        _vm._l(_vm.productsIcons.virtual, function(item, i) {
                          return _c(
                            "v-btn",
                            {
                              key: i,
                              staticClass: "ma-2 option-toggle__btn",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.saveSolution($event)
                                }
                              }
                            },
                            [
                              _c("i", { class: item.icon }),
                              _c("div", { staticClass: "text-xs-left pl-3" }, [
                                _c("h3", {
                                  domProps: { innerHTML: _vm._s(item.title) }
                                }),
                                _c("p", {
                                  staticClass: "mb-0",
                                  domProps: { innerHTML: _vm._s(item.subtitle) }
                                })
                              ]),
                              _c("span", {
                                staticClass: "icon-ic-check",
                                class: {
                                  showCheck:
                                    i + _vm.productsIcons.presential.length ===
                                    _vm.selectedIndex
                                }
                              })
                            ]
                          )
                        })
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "button-container" },
        [
          _c(
            "v-btn",
            {
              staticClass: "primary-button text black_second capitalize",
              attrs: { small: "", outline: "", to: "/dashboard" }
            },
            [_vm._v("Atrás")]
          )
        ],
        1
      ),
      _c("loader", {
        ref: "loaderModal",
        attrs: { text: "Seleccionando Producto" }
      }),
      _c("v-layout", {
        staticClass: "mt-5",
        attrs: { row: "", "justify-center": "" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-924cda66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-924cda66","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/product-choice.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-924cda66","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/product-choice.vue
// module chunks = 0 1 2 3